import classNames from 'classnames'

import type { PropsWithChildren, ReactElement } from 'react'

interface Props {
  className?: string
}

export const ModalHeader = ({ children, className }: PropsWithChildren<Props>): ReactElement => {
  return <div className={classNames('modal-component__header', className, 'modal-padding')}>{children}</div>
}

export const ModalFooter = ({ children, className }: PropsWithChildren<Props>): ReactElement => {
  return <div className={classNames('modal-component__footer', className, 'modal-padding')}>{children}</div>
}

export const ModalBody = ({ children, className }: PropsWithChildren<Props>): ReactElement => {
  return <div className={classNames('modal-component__body', className, 'modal-padding')}>{children}</div>
}
